import { CustomerResponseInterface } from '@careapp/angular-sdk';

import { Customers, CustomerFiles } from '../actions';
import { DataListState } from './data-list.state';
import { ReducerStateFactory } from './state-factory.reducer';

class CustomersReducer extends ReducerStateFactory<CustomerResponseInterface> {
  constructor() {
    super(Customers);
  }

  reducer(
    state: DataListState<CustomerResponseInterface> = this.initialState,
    action: any
  ): DataListState<CustomerResponseInterface> {
    switch (action.type) {
      case Customers.REQUEST_SAVE:
        return { ...state, loadingAll: true };
      case Customers.RESPONSE_FAIL_ALL:
      case Customers.RESPONSE_FAIL_CREATE:
      case Customers.RESPONSE_FAIL_SAVE:
      case Customers.RESPONSE_FAIL:
        return { ...state, loadingAll: false };
      case Customers.RESPONSE_SUCCESS_SAVE: {
        const ids = Array.from(new Set([...state.ids, action.payload.id]));
        const entities = { ...state.entities, [action.payload.id]: action.payload };
        return { ...state, loadingAll: false, ids: ids, entities: entities };
      }
      case Customers.RESPONSE_SUCCESS_ADD_CUSTOMER_FILE: {
        const customer = { ...state.entities[action.payload.modelId] };
        customer.files = [...customer.files, action.payload];
        return { ...state, entities: { ...state.entities, [action.payload.modelId]: customer } };
      }
      case CustomerFiles.RESPONSE_SUCCESS_DESTROY_BY_ID: {
        const customer = { ...state.entities[action.payload.modelId] };
        customer.files = customer.files.filter(item => item.id !== action.payload.id);
        return { ...state, entities: { ...state.entities, [action.payload.modelId]: customer } };
      }
    }
    return super.reducer(state, action);
  }
}

export const state = new CustomersReducer();

export function reducer(...args) {
  return state.reducer.apply(state, args);
}

export const getEntities = (state: any) => state.entities;
